import React from "react";

const services = [
  {
    title: "Project Health",
    description: [
      "Inspect all aspects of the project",
      "Thorough analysis of all phases",
      "Health report covering all domains",
      "Covers quality audit aspects",
      "Benefits the stakeholder to understand areas of improvement",
      "Benefits the organization with enhanced efficacy and overall cost effectiveness"
    ]
  },
  {
    title: "Operations Health",
    description: [
      "Inspect operations management from support perspective",
      "Analyse BAU function and support",
      "Report highlighting ideas of better performance",
      "Benefit to end customers for a better Turnaround",
      "Ideas for efficient and optimized performance of the support team"
    ]
  },
  {
    title: "Operations Excellence",
    description: [
      "Optimize workflows",
      "Enhance productivity",
      "Reduce overhead"
    ]
  }
];

export default function Services() {
  return (
    <section id="services" className="py-20 px-6 bg-gray-500">
      <h2 className="text-4xl font-bold text-center text-white mb-5">Our Services</h2>
      <p className="text-2xl text-center text-white mb-10">Comprehensive consulting solutions for transforming your business and accelarating your path to success.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 max-w-7xl mx-auto">
        {services.map((s, i) => (
          <div key={i} className="bg-gray-700 p-8 rounded-2xl shadow-xl hover:shadow-2xl transition">
            <h3 className="text-2xl font-semibold text-green-500 mb-4">
              {s.title}
            </h3>
            <p className="text-white text-md leading-relaxed">
              {s.description.map((line, index) => (
                <li key={index}>{line}</li>
              ))}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
